import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const propTypes = {
  text: PropTypes.string,
};

const EmptyBlock = ({ text }) => <div className={style.emptyBlock}>{text}</div>;

EmptyBlock.propTypes = propTypes;

export default EmptyBlock;
